import Animation from "./Animation/Animation";

const Skeleton = ({ width = 100, height = 20 }) => {
  return (
    <div
      style={{ width, height }}
      className="bg-[#f0f0f0] overflow-hidden rounded"
    >
      <Animation classes={"via-[#a3a3a3]/60"} />
    </div>
  );
};

export default Skeleton;
